const ITEMS = ["Travel Your Way", "Experience Like a Local", "Private & Small-Group", "Never from a Template"];

export default function Marquee() {
    return (
        <section className="border-y border-gold/25 bg-cream py-5 overflow-hidden" aria-label="Travel Your Way — Experience Like a Local">
            <div className="flex w-max animate-marquee-drift">
                {[0, 1].map((copy) => (
                    <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
                        {ITEMS.map((t) => (
                            <span key={`${copy}-${t}`} className="flex items-center">
                                <span className="mx-8 font-serif italic text-lg text-navy/75 whitespace-nowrap">{t}</span>
                                <span className="h-1 w-1 rounded-full bg-gold" aria-hidden="true" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}
